/**
 * 兼容后端“JSON 字符串 / 普通字符串”混合返回的字段。
 *
 * 能解析时返回 JSON 值，不能解析时保留原值，避免单条旧数据中断整批列表渲染。
 */
export function parseJsonIfPossible(value: unknown): unknown {
  if (!value || typeof value !== 'string') {
    return value
  }

  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}
